/* Spotlight figure follows the banner slide */
(function () {
  'use strict';
  var spot = document.querySelector('[data-zspot]');
  var slides = [].slice.call(document.querySelectorAll('[data-zslider] [data-zslide]'));
  if (!spot || !slides.length) return;
  var items = [].slice.call(spot.querySelectorAll('.zspot-s'));
  var cur = -1;
  function sync() {
    var k = 0;
    slides.forEach(function (s, n) { if (s.style.opacity === '1') k = n; });
    k = k % items.length;
    if (k === cur) return;
    cur = k;
    items.forEach(function (el, n) { el.classList.toggle('on', n === k); });
    spot.setAttribute('href', items[k].getAttribute('data-href'));
    spot.style.backgroundColor = items[k].getAttribute('data-bg');
  }
  var mo = new MutationObserver(sync);
  slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['style'] }); });
  sync();
})();

/* Quick add: bag button that turns into a minus / count / plus control once added */
(function () {
  'use strict';
  var forms = [].slice.call(document.querySelectorAll('form[data-zquick]'));
  if (!forms.length) return;
  var st = document.createElement('style');
  st.textContent = '.zqstep{display:inline-flex;align-items:center;height:42px;border-radius:21px;border:1.5px solid #14301c;background:#e6dcf5;color:#14301c;overflow:hidden;animation:zquickpop .35s cubic-bezier(.3,1.6,.5,1)}'
    + '.zqstep button{width:36px;height:100%;border:0;background:none;color:inherit;font:inherit;font-size:20px;font-weight:600;line-height:1;cursor:pointer;padding:0;transition:background .2s ease}'
    + '.zqstep button:hover{background:#d5c6ee}.zqstep button:disabled{opacity:.45;cursor:wait}'
    + '.zqstep b{min-width:22px;text-align:center;font-family:Montserrat,sans-serif;font-weight:800;font-size:15px;line-height:1}'
    + '.zqstep[hidden],.zquick[hidden]{display:none}';
  document.head.appendChild(st);
  function say(msg) {
    var t = document.getElementById('toast');
    if (t) { t.textContent = msg; t.hidden = false; setTimeout(function () { t.hidden = true; }, 4000); }
  }
  function count(cart) {
    [].forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = cart.item_count; });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not update the cart'); return d; }); });
  }
  var rows = forms.map(function (form) {
    var id = form.querySelector('input[name=id]').value;
    var btn = form.querySelector('button');
    var step = document.createElement('span');
    step.className = 'zqstep';
    step.hidden = true;
    step.innerHTML = '<button type="button" data-d="-1" aria-label="One less">−</button><b aria-live="polite">0</b><button type="button" data-d="1" aria-label="One more">+</button>';
    form.appendChild(step);
    var out = step.querySelector('b');
    var row = { id: id, n: 0 };
    row.show = function (n) {
      row.n = n;
      out.textContent = n;
      step.hidden = n < 1;
      btn.hidden = n > 0;
    };
    function busy(on) { [].forEach.call(form.querySelectorAll('button'), function (x) { x.disabled = on; }); }
    function sync(cart) { count(cart); rows.forEach(function (r) { r.show(qty(cart, r.id)); }); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      busy(true);
      post('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(sync)
        .catch(function (err) { say(err.message); })
        .then(function () { busy(false); });
    });
    step.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-d]');
      if (!b) return;
      busy(true);
      post('/cart/change.js', { id: String(id), quantity: Math.max(0, row.n + parseInt(b.getAttribute('data-d'), 10)) })
        .then(sync)
        .catch(function (err) { say(err.message); })
        .then(function () { busy(false); });
    });
    return row;
  });
  function qty(cart, id) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (String(it.variant_id) === String(id)) n += it.quantity; });
    return n;
  }
  function pull() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { rows.forEach(function (r) { r.show(qty(cart, r.id)); }); }).catch(function () {});
  }
  pull();
  /* stay in step when the side cart changes the quantities */
  var badge = document.querySelector('[data-cart-count]');
  if (badge && window.MutationObserver) new MutationObserver(pull).observe(badge, { childList: true, characterData: true, subtree: true });
})();

/* Routine cards: a single tick to include or leave out each product */
(function () {
  'use strict';
  var TICK = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
  [].forEach.call(document.querySelectorAll('[data-zrt-item]'), function (item) {
    var minus = item.querySelector('[data-zrt-minus]'), plus = item.querySelector('[data-zrt-plus]'), out = item.querySelector('[data-zrt-n]');
    var name = item.querySelector('.zrt-name');
    if (!minus || !plus || !out) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'zrt-pick';
    b.innerHTML = TICK;
    b.setAttribute('aria-pressed', 'true');
    b.setAttribute('aria-label', 'Include ' + (name ? name.textContent : 'this product'));
    b.addEventListener('click', function () {
      var on = (parseInt(out.textContent, 10) || 0) > 0;
      (on ? minus : plus).click();
      b.setAttribute('aria-pressed', on ? 'false' : 'true');
    });
    item.appendChild(b);
    item.classList.add('zrt-simple');
  });
})();

/* Search pop-up: call and contact options */
(function () {
  'use strict';
  var pop = document.querySelector('dialog.zsp');
  if (!pop || pop.querySelector('.zsp-help')) return;
  var d = document.createElement('div');
  d.className = 'zsp-help';
  d.innerHTML = '<span>Need help choosing?</span>'
    + '<a class="zsp-call" href="tel:+919958533360" aria-label="Call Zeel on +91 99585 33360"><svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"></path></svg>+91 99585 33360</a>'
    + '<a href="/pages/contact">Contact us</a>';
  pop.appendChild(d);
})();

/* Shop menu: close by itself once the mouse moves away from the button and the panel */
(function () {
  var root = document.querySelector('[data-zmenu-root]');
  if (!root) return;
  var btn = root.querySelector('[data-zmenu-btn]');
  var panel = root.querySelector('[data-zmenu-panel]');
  if (!btn || !panel) return;
  var st = document.createElement('style');
  st.textContent = '[data-zmenu-root] [data-zmenu-btn][aria-expanded=true]{background:#e6dcf5!important;color:#14301c!important;box-shadow:inset 0 0 0 1.5px #c9b8ea}';
  st.textContent += '.zmm-h{display:flex;align-items:center;justify-content:space-between;gap:10px}.zmm-c{flex:none;min-width:22px;height:22px;padding:0 6px;box-sizing:border-box;border-radius:11px;background:#f1ecf9;color:#5b3fa0;display:inline-flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;letter-spacing:0;line-height:1}';
  document.head.appendChild(st);
  /* how many products sit under each category heading */
  [].forEach.call(panel.querySelectorAll('.zmm-h'), function (h) {
    var n = 0, el = h.nextElementSibling;
    while (el && !el.classList.contains('zmm-h')) { if (el.classList.contains('zmi')) n++; el = el.nextElementSibling; }
    var c = document.createElement('span');
    c.className = 'zmm-c';
    c.textContent = n;
    c.setAttribute('aria-label', n + (n === 1 ? ' product' : ' products'));
    h.appendChild(c);
  });
  var t = null;
  function inside(e) {
    var x = e.clientX, y = e.clientY, m = 14;
    var b = btn.getBoundingClientRect();
    var p = (panel.firstElementChild || panel).getBoundingClientRect();
    if (x >= b.left - m && x <= b.right + m && y >= b.top - m && y <= b.bottom + m) return true;
    if (x >= p.left - m && x <= p.right + m && y >= b.bottom && y <= p.bottom + m) return true;
    return false;
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || panel.hidden) return;
    if (inside(e)) { clearTimeout(t); t = null; return; }
    if (!t) t = setTimeout(function () { t = null; if (!panel.hidden) btn.click(); }, 280);
  });
})();
